import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", { class: "text-4xl text-primary-700 font-bold" }, "Account Details", -1)
const _hoisted_2 = { class: "bg-white rounded-lg px-5 py-9" }
const _hoisted_3 = {
  key: 0,
  class: "grid grid-cols-1 lg:grid-cols-2 gap-3 lg:gap-[45px]"
}
const _hoisted_4 = { class: "space-y-3" }
const _hoisted_5 = { class: "flex justify-between items-center" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", null, "First Name", -1)
const _hoisted_7 = { class: "font-bold" }
const _hoisted_8 = { class: "flex justify-between items-center" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", null, "Middle Name", -1)
const _hoisted_10 = { class: "font-bold" }
const _hoisted_11 = { class: "flex justify-between items-center" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", null, "Last Name", -1)
const _hoisted_13 = { class: "font-bold" }
const _hoisted_14 = { class: "flex justify-between items-center" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("p", null, "Suffix", -1)
const _hoisted_16 = { class: "font-bold" }
const _hoisted_17 = { class: "space-y-3" }
const _hoisted_18 = { class: "flex justify-between items-center" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("p", null, "Email", -1)
const _hoisted_20 = { class: "font-bold" }
const _hoisted_21 = { class: "flex justify-between items-center" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("p", null, "Mobile Number", -1)
const _hoisted_23 = { class: "flex items-center space-x-2" }
const _hoisted_24 = { class: "font-bold" }
const _hoisted_25 = { class: "flex justify-between items-center" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("p", null, "Birthday", -1)
const _hoisted_27 = { class: "font-bold" }
const _hoisted_28 = { class: "flex justify-between items-center" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("p", null, "Sex", -1)
const _hoisted_30 = { class: "font-bold" }

import PortalLayout from '@/layouts/PortalLayout.vue';
import PageLoader from "@/components/PageLoader.vue";
import { PencilSquareIcon } from '@heroicons/vue/24/outline';

import { computed, onMounted, ref } from 'vue';
import { useRouter } from 'vue-router';
import patient from "@/classes/UserData";
import { format } from 'date-fns'


export default /*#__PURE__*/_defineComponent({
  __name: 'AccountDetails',
  setup(__props) {

const router = useRouter();

const loader = ref(false)

const patientData = computed(() => patient.getCurrentUser())
const item = ref(null)

const fetchData = () => {
    loader.value = true
    

    patient.getPatient(patientData.value.email_address)
        .then((result: any) => {
            loader.value = false
            item.value = result.data;
        })
        .catch((err) => {
            loader.value = false
            if(err.response.status == 401) {
                window.location.replace('/login')
            }
        })
}

onMounted(() => {
    fetchData();
})



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(PortalLayout, { defaultTitle: false }, {
    title: _withCtx(() => [
      _hoisted_1
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        (item.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _hoisted_6,
                  _createElementVNode("p", _hoisted_7, _toDisplayString(item.value.First_Name || '--'), 1)
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _hoisted_9,
                  _createElementVNode("p", _hoisted_10, _toDisplayString(item.value.Middle_Name || '--'), 1)
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _hoisted_12,
                  _createElementVNode("p", _hoisted_13, _toDisplayString(item.value.Last_Name || '--'), 1)
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _hoisted_15,
                  _createElementVNode("p", _hoisted_16, _toDisplayString(item.value.Suffix || '--'), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _hoisted_19,
                  _createElementVNode("p", _hoisted_20, _toDisplayString(item.value.Email || '--'), 1)
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _hoisted_22,
                  _createElementVNode("div", _hoisted_23, [
                    _createVNode(_unref(PencilSquareIcon), {
                      class: "w-5 h-5 text-[#23A2B4] cursor-pointer",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push('/account-details/edit')))
                    }),
                    _createElementVNode("p", _hoisted_24, "+63" + _toDisplayString(item.value.Mobile || '--'), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_25, [
                  _hoisted_26,
                  _createElementVNode("p", _hoisted_27, _toDisplayString(_unref(format)(new Date(item.value.Date_of_Birth ), 'MMMM dd, Y') || '--'), 1)
                ]),
                _createElementVNode("div", _hoisted_28, [
                  _hoisted_29,
                  _createElementVNode("p", _hoisted_30, _toDisplayString(item.value.Sex || '--'), 1)
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      (loader.value)
        ? (_openBlock(), _createBlock(PageLoader, { key: 0 }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})